// Globales Theme-JS.

/**
 * refreshCartCount – holt den aktuellen Warenkorb-Zähler via /cart.js
 * und schreibt cart.item_count in alle [data-cart-count]-Elemente.
 */
async function refreshCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });
  } catch (e) {
    // Fail silently – Zähler bleibt auf dem vom Server gerenderten Wert
  }
}

window.addEventListener('pageshow', event => {
  if (event.persisted) refreshCartCount();
});
